import React from 'react';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { Button } from 'swag-client-common/components/ui/button';
import { ButtonFontSize, ButtonSize, ButtonTextTransform, ButtonType } from 'swag-client-common/components/ui/button/button';
import { capitalize } from 'swag-common/utils/strings';
import { SwagBundleAddonTypeInEditApprovePopupEnum } from '../../../interfaces/swag-bundles.interface';
import classes from './swag-bundle-edit-addons-remove-approving-popup.scss';
export let SwagBundleEditAddonsApproveConfirmationAction = /*#__PURE__*/function (SwagBundleEditAddonsApproveConfirmationAction) {
  SwagBundleEditAddonsApproveConfirmationAction["SAVE_AND_EXIT"] = "SAVE_AND_EXIT";
  SwagBundleEditAddonsApproveConfirmationAction["NEXT_STEP"] = "NEXT_STEP";
  SwagBundleEditAddonsApproveConfirmationAction["PREV_STEP"] = "PREV_STEP";
  return SwagBundleEditAddonsApproveConfirmationAction;
}({});
export const SwagBundleEditAddonsRemoveApprovingPopupComponent = props => {
  const {
    isOpen,
    editAddonType,
    approveConfirmationAction,
    onClose,
    onNextStep,
    onPrevStep,
    onSaveAndExit,
    onConfirm
  } = props;
  const handleConfirmAction = () => {
    onConfirm();
    switch (approveConfirmationAction) {
      case SwagBundleEditAddonsApproveConfirmationAction.SAVE_AND_EXIT:
        onSaveAndExit();
        break;
      case SwagBundleEditAddonsApproveConfirmationAction.NEXT_STEP:
        onNextStep();
        break;
      case SwagBundleEditAddonsApproveConfirmationAction.PREV_STEP:
        onPrevStep();
        break;
      default:
        onClose();
    }
  };
  const isBothAddons = editAddonType === SwagBundleAddonTypeInEditApprovePopupEnum.BothAddons;
  const addonsText = isBothAddons ? 'add-ons' : `custom ${editAddonType}`;
  const renderContent = () => {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
      className: classes.title
    }, /*#__PURE__*/React.createElement("span", null, "Hey, you're removing your ", addonsText, " from this box!")), /*#__PURE__*/React.createElement("div", {
      className: classes.textWrapper
    }, /*#__PURE__*/React.createElement("p", {
      className: classes.text
    }, "Once removed, your custom", ' ', isBothAddons ? 'packaging and notecards' : editAddonType, " will appear in your inventory so you can reuse them as needed. Are you sure you want to remove your ", addonsText, " from this box?")), /*#__PURE__*/React.createElement("div", {
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      dataButton: "Cancel",
      type: ButtonType.primaryOutlined,
      size: ButtonSize.large,
      fontSize: ButtonFontSize.small,
      onClick: onClose,
      textTransform: ButtonTextTransform.none
    }, "No Thanks"), /*#__PURE__*/React.createElement(Button, {
      dataButton: "Remove",
      type: ButtonType.primary,
      size: ButtonSize.large,
      fontSize: ButtonFontSize.small,
      onClick: handleConfirmAction,
      textTransform: ButtonTextTransform.none
    }, "Remove ", isBothAddons ? 'Add-ons' : capitalize(editAddonType))));
  };
  return /*#__PURE__*/React.createElement(PopupDialog, {
    dataPopup: "EditBundleRemoveAddonsConfirmation",
    open: isOpen,
    onClose: onClose,
    contentClass: classes.content,
    content: renderContent(),
    classes: {
      paper: classes.paper
    },
    isResponsive: true
  });
};